firebird.controller('advancedSettingsCtrl', [
    '$rootScope',
    '$scope',
    '$window',
    '$timeout',
    'logService',
    'attendeeService',
    'storageService',
    'socketService',
    'configService',
    'meetingService',
    'localizationService',
    'analyticsWrapperService',
    'helperService',
    function (
        $rootScope,
        $scope,
        $window,
        $timeout,
        logService,
        attendeeService,
        storageService,
        socketService,
        configService,
        meetingService,
        localizationService,
        analyticsWrapperService,
        helperService
    ) {
        var self = this;

        const logger = logService.createLoggerWithSource('advancedSettingsCtrl');

        self.settings = {};
        self.hasVideoFilter = !!configService.getServerValue('videoFilter'); // temporarily move the feature behind user pair.
        self.videoFilterValue = null;
        self.videoFilterEnabled = false;
        self.meetingOptions = '';
        self.layoutLockAvailable = configService.isLayoutLockAvailable();
        self.layoutLockEnabled = configService.isLayoutLockLocked();
        self.sfuEnabled = meetingService.getIsSfuEnabled() && helperService.getIsRedesign();

        self.showImproveCpuPerformanceCheckbox = meetingService.getEnableAutoPerformanceMode() === false;

        self.isHost = attendeeService.getIsHost(true);

        self.cancel = cancel;
        self.save = save;
        self.initSettings = initSettings;
        self.isEqual = isEqual;

        self.onVideoFilterToggled = onVideoFilterToggled;
        self.onVideoFilterSelect = onVideoFilterSelect;
        self.onVideoFilterFileSelect = onVideoFilterFileSelect;

        self.saveAdvancedSettings = saveAdvancedSettings;
        self.saveVideoFilter = saveVideoFilter;
        self.saveLayoutLockEnabled = saveLayoutLockEnabled;

        self.onCPUPerformanceSettingChange = onCPUPerformanceSettingChange;

        $scope.$on('settings-view-state-change', onSettingsViewStateChanged);
        $scope.$on('settings-modal-closed', onSettingsModalClosed);
        $scope.$on('advanced-settings-changed', onAdvancedSettingsChanged);

        init();

        ////////////////////////

        function init() {
            logger.debug('advancedSettingsCtrl init');
            self.initSettings();

            $timeout(function () {
                $window.$('#select-video-background').click(self.onVideoFilterSelect);
                $window.$('#video-background-file-upload').change(self.onVideoFilterFileSelect);
            });
        }

        function initSettings() {
            self.settings = deserialize(storageService.get('advancedSettings'));
            self.videoFilterValue = storageService.get('videoFilter');
            if (self.videoFilterValue && self.videoFilterValue.startsWith('change-bg:blob:')) {
                self.videoFilterValue = null; // do not load blob url from last time.
            }
            self.videoFilterEnabled = !!self.videoFilterValue;
        }

        function deserialize(string) {
            var settings = JSON.parse(string || '{}');
            var remaining = [];
            for (var attr in settings) {
                if (attr == 'iceTransport' && settings[attr] == 'relay') {
                    settings.useRelay = true;
                    delete settings[attr];
                } else if (attr == 'videoResolutionScreen' && settings[attr] == 'native') {
                    settings.useNativeScreen = true;
                    delete settings[attr];
                } else if (attr == 'videocodec' && settings[attr] == 'h264') {
                    delete settings[attr];
                } else if (attr == 'videoFilter' && !!(settings.videoFilter || '').match(/\bwasm\b/)) {
                    settings.useWasm = true;
                    delete settings[attr];
                } else if (attr == 'videoLow' && settings[attr] == 'true') {
                    if (meetingService.getEnableAutoPerformanceMode() === false) {
                        settings.videoLow = true;
                    } else {
                        delete settings[attr];
                    }
                } else {
                    remaining.push(attr);
                }
            }
            if (remaining.length > 0) {
                settings.urlParams = remaining
                    .sort()
                    .map(function (attr) {
                        return encodeURIComponent(attr) + '=' + encodeURIComponent('' + settings[attr]);
                    })
                    .join('&');
            }

            return settings;
        }

        function serialize(settings) {
            var data = {};
            var remaining = [];
            for (var attr in settings) {
                if (attr == 'useRelay' && settings[attr]) {
                    data.iceTransport = 'relay';
                } else if (attr == 'useNativeScreen' && settings[attr]) {
                    data.videoResolutionScreen = 'native';
                } else if (attr == 'useWasm' && settings[attr]) {
                    data.videoFilter = '{"engine":"wasm"}'; // default is webgl when true
                } else if (attr == 'videoLow' && settings[attr] == true) {
                    if (meetingService.getEnableAutoPerformanceMode() === false) {
                        data.videoLow = 'true';
                    }
                }
            }
            if (settings.urlParams) {
                settings.urlParams.split('&').map(function (nv) {
                    var index = nv.indexOf('=');
                    var attr = index >= 0 ? nv.substr(0, index) : nv;
                    var value = index >= 0 ? nv.substr(index + 1) : null;
                    data[decodeURIComponent(attr)] = value && decodeURIComponent(value);
                });
            }
            return JSON.stringify(data);
        }

        function save() {
            self.saveVideoFilter();
            self.saveAdvancedSettings();
            self.saveLayoutLockEnabled();
        }

        function onCPUPerformanceSettingChange(previous, current) {
            if (previous.videoLow && !current.videoLow) {
                analyticsWrapperService.eventTrack('Meeting - Performance Mode Disabled from Advanced Settings');
            } else if (!previous.videoLow && current.videoLow) {
                analyticsWrapperService.eventTrack('Meeting - Performance Mode Enabled from Advanced Settings');
            }
        }

        function saveVideoFilter() {
            var previous = storageService.get('videoFilter');
            logger.log('saveVideoFilter ' + !!previous + ' => ' + !!self.videoFilterValue);
            if (previous !== self.videoFilterValue) {
                if (self.videoFilterValue) {
                    storageService.set('videoFilter', self.videoFilterValue);
                } else {
                    storageService.remove('videoFilter');
                }
                $rootScope.$broadcast('video-filter-changed', {
                    oldValue: previous,
                    newValue: self.videoFilterValue
                });
            }
        }

        function saveAdvancedSettings() {
            var previous = deserialize(storageService.get('advancedSettings') || '{}');
            //ignore videoLow
            delete previous.videoLow;
            delete self.settings.videoLow;

            ['useRelay', 'useNativeScreen', 'useWasm', 'urlParams', 'videoLow'].forEach(function (attr) {
                if (self.settings[attr] !== undefined && !self.settings[attr]) {
                    // false or 0 or empty string
                    delete self.settings[attr]; // remove if default values.
                }
            });

            if (!isEqual(previous, self.settings)) {
                self.onCPUPerformanceSettingChange(previous, self.settings);

                // Get changed attributes
                var changedAttrs = getAttrDiff(previous, self.settings);

                // Track analytics for advanced settings changes
                if (changedAttrs.length > 0) {
                    var changedSettingsWithValues = changedAttrs.map(function (attr) {
                        var value = self.settings.hasOwnProperty(attr) ? self.settings[attr] : 'removed';
                        return attr + '=' + value;
                    });
                    analyticsWrapperService.eventTrack('Meeting - Advanced Settings Changed', {
                        changedSettings: changedSettingsWithValues.join(', ')
                    });
                }

                if (isEqual(self.settings, {})) {
                    storageService.remove('advancedSettings');
                } else {
                    storageService.set('advancedSettings', serialize(self.settings));
                }
                if (!self.meetingOptions) {
                    $timeout(function () {
                        $rootScope.$broadcast('advanced-settings-changed', changedAttrs);
                    }, 3000);
                } // else it will broadcast this when triggered by server on updated-meeting-sfupayload
            }

            if (self.meetingOptions) {
                console.log('meeting options=' + self.meetingOptions);
                var data = {};
                self.meetingOptions.split('&').map(function (nv) {
                    var index = nv.indexOf('=');
                    var attr = decodeURIComponent(index >= 0 ? nv.substr(0, index) : nv).substr(0, 32); // limit size to at most 32
                    var value = index >= 0 ? decodeURIComponent(nv.substr(index + 1)).substr(0, 32) : null;
                    data[attr] = value;
                });
                socketService.send({ message: 'update-meeting-sfupayload', data: data });
            }
        }

        function saveLayoutLockEnabled() {
            var previous = configService.isLayoutLockLocked();
            if (previous !== self.layoutLockEnabled) {
                logger.log('saveLayoutLockEnabled ' + previous + ' => ' + self.layoutLockEnabled);
                // Do not save in local storage, as this is to be stored at/retrieved from server.
                socketService.send({
                    message: 'update-meeting-sfupayload',
                    data: { layoutLock: self.layoutLockEnabled ? 'locked' : 'available' }
                });
            }
        }

        function onVideoFilterToggled() {
            if (self.videoFilterEnabled) {
                self.videoFilterValue = 'blur-bg';
            } else {
                self.videoFilterValue = null;
            }
        }

        function onVideoFilterSelect() {
            self.videoFilterValue = 'remove-bg';
            self.videoFilterEnabled = true;
            digest();

            $window.$('#video-background-file-upload').click();
        }

        function onVideoFilterFileSelect() {
            var file = $window.$('#video-background-file-upload')[0].files[0];
            if (file) {
                if (file.type == 'video/mp4') {
                    // this won't be available next time.
                    self.videoFilterValue = 'change-bg:' + URL.createObjectURL(file);
                    logger.log('changed video filter to ' + self.videoFilterValue.substr(0, 100));
                    self.videoFilterEnabled = true;
                    digest();
                } else if (file.type && file.type.startsWith('image/')) {
                    var image = new Image();
                    image.onload = function (event) {
                        var w = image.naturalWidth || image.width,
                            h = image.naturalHeight || image.height;
                        var canvas = document.createElement('canvas');
                        canvas.width = 640;
                        canvas.height = 360;
                        canvas.getContext('2d').drawImage(image, 0, 0, w, h, 0, 0, 640, 360);

                        var dataURL = canvas.toDataURL('image/jpeg');
                        self.videoFilterValue = 'change-bg:' + dataURL;
                        self.videoFilterEnabled = true;

                        digest();
                    };
                    image.src = URL.createObjectURL(file);
                } else {
                    logger.error('onVideoFilterFileSelect', 'only video or image file can be selected', file.type);
                    self.videoFilterEnabled = false;
                    self.videoFilterValue = '';
                }
                $window.$('#video-background-file-upload').val('');
            }
        }

        function cancel() {
            self.initSettings();
        }

        function isEqual(a, b) {
            var aProps = Object.getOwnPropertyNames(a);
            var bProps = Object.getOwnPropertyNames(b);

            if (aProps.length != bProps.length) {
                return false;
            }

            for (var i = 0; i < aProps.length; i++) {
                var propName = aProps[i];
                if (a[propName] !== b[propName]) {
                    return false;
                }
            }

            return true;
        }

        // return an array containing all attr names that are different between a and b: added, removed, or modified.
        function getAttrDiff(a, b) {
            const result = [];
            const attrs1 = new Set(Object.getOwnPropertyNames(a));
            const attrs2 = new Set(Object.getOwnPropertyNames(b));
            const allAttrs = new Set([...attrs1, ...attrs2]);

            allAttrs.forEach(function (attr) {
                if (attrs1.has(attr) && attrs2.has(attr)) {
                    // Check if modified
                    if (a[attr] !== b[attr]) {
                        result.push(attr);
                    }
                } else {
                    // Added to b or removed from a
                    result.push(attr);
                }
            });

            return result;
        }

        function onSettingsViewStateChanged(e, data) {
            if (data) {
                var tabName = 'advanced-settings';

                if (data.openedTab === tabName) {
                    logger.log('advanced Settings Tab opened');
                } else if (data.closedTab === tabName) {
                    logger.log('advanced Settings Tab closed');
                }
            }
        }

        function onSettingsModalClosed(e, data) {
            if (data && data.applyChanges) {
                logger.log('Advanced Settings - applying changes');
                self.save();
            } else {
                logger.log('Advanced Settings - closing without applying changes');
                self.cancel();
            }
        }

        function onAdvancedSettingsChanged(e, data) {
            //Layout Lock setting can be changed from Beta Settings, so we need this to keep both Layout Locked checkboxes synced
            if (data && data.indexOf('layoutLock') > -1) {
                self.layoutLockEnabled = configService.isLayoutLockLocked();
                digest();
            }
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }
    }
]);
